export class UpdateCompany {
    constructor(companyRepository) {
      this.companyRepository = companyRepository;
    }
  
    async execute(company) {
      return await this.companyRepository.updateCompany(company);
    }
  }